export const SEO_CONFIG = {
  default: {
    title: "Flexaura — Pay Monthly for Travel, Education & Healthcare",
    description: "Spread the cost of travel, school fees and healthcare across monthly payments with trusted BNPL providers. UAE's leading financing marketplace.",
    image: "https://flexaura.me/og-default.jpg",
    url: "https://flexaura.me/",
  },
  travel: {
    title: "Pay Monthly for Travel | Flexaura UAE",
    description: "Book flights, hotels and holiday packages and pay monthly with Tabby, Tamara or Cashew. No interest. UAE-wide coverage.",
    image: "https://flexaura.me/og-travel.jpg",
    url: "https://flexaura.me/travel",
  },
  education: {
    title: "Pay Monthly for School Fees | Flexaura UAE",
    description: "Pay UAE school and university fees in monthly instalments. British, American, IB and CBSE curricula. Starting from AED 500/month.",
    image: "https://flexaura.me/og-education.jpg",
    url: "https://flexaura.me/education",
  },
  healthcare: {
    title: "Finance Medical Treatments | Flexaura UAE",
    description: "Finance dental, cosmetic, bariatric and specialist healthcare in the UAE. Pay monthly with trusted BNPL providers.",
    image: "https://flexaura.me/og-healthcare.jpg",
    url: "https://flexaura.me/healthcare",
  },
  auth: {
    title: "Sign In | Flexaura",
    description: "Sign in to your Flexaura account to manage bookings, points and rewards.",
    url: "https://flexaura.me/auth",
  },
  dashboard: {
    title: "My Account | Flexaura",
    description: "Manage your bookings, points and rewards.",
    url: "https://flexaura.me/account/dashboard",
  },
  faq: {
    title: "FAQ — Frequently Asked Questions | Flexaura",
    description: "Everything you need to know about financing travel, education and healthcare with Flexaura.",
    url: "https://flexaura.me/faq",
  },
  partners: {
    title: "Partner with Flexaura | List Your Business",
    description: "Join UAE's leading BNPL marketplace. List your travel, education or healthcare business and reach thousands of GCC families.",
    url: "https://flexaura.me/partners",
  },
  about: {
    title: "About Flexaura | Our Story & Mission",
    description: "Flexaura makes life's biggest milestones affordable across the UAE. Learn how we connect families with trusted BNPL and bank instalment partners.",
    url: "https://flexaura.me/about",
  },
  contact: {
    title: "Contact Flexaura | Get In Touch",
    description: "Questions about a booking, a payment plan or a partnership? Reach the Flexaura team by email, WhatsApp or our contact form.",
    url: "https://flexaura.me/contact",
  },
  privacy: {
    title: "Privacy Policy | Flexaura",
    description: "How Flexaura collects, uses and protects your personal data — UAE PDPL compliant.",
    url: "https://flexaura.me/privacy",
  },
  terms: {
    title: "Terms of Use | Flexaura",
    description: "The terms governing your use of the Flexaura marketplace and the licensed financial partners we connect you with.",
    url: "https://flexaura.me/terms",
  },
  refund: {
    title: "Refund Policy | Flexaura",
    description: "How refunds, cancellations and disputes are handled across Flexaura, our merchants and our financing partners.",
    url: "https://flexaura.me/refund",
  },
  investors: {
    title: "For Investors | Flexaura",
    description: "Flexaura's investor information — market opportunity, traction and how to get in touch.",
    url: "https://flexaura.me/investors",
  },
  marketplace: {
    title: "Flexaura Marketplace | Travel, Education & Healthcare",
    description: "Browse Flexaura's marketplace of travel, education and healthcare merchants offering monthly payment plans across the UAE.",
    url: "https://flexaura.me/marketplace",
  },
  payMonthlyTravel: {
    title: "Pay Monthly for Travel UAE | Flexaura",
    description: "Pay monthly for travel packages, flights and hotels in the UAE. Compare BNPL travel options and bank instalments from AED 2K-200K+.",
    url: "https://flexaura.me/pay-monthly-travel",
  },
  payMonthlyEducation: {
    title: "Pay Monthly for Education UAE | Flexaura",
    description: "Pay monthly for school fees, courses and training programs in the UAE. Compare BNPL and bank instalments from AED 2K-200K+.",
    url: "https://flexaura.me/pay-monthly-education",
  },
  payMonthlyHealthcare: {
    title: "Pay Monthly for Healthcare UAE | Flexaura",
    description: "Pay monthly for medical, dental and cosmetic treatments in the UAE. Compare BNPL and bank instalments from AED 2K-200K+.",
    url: "https://flexaura.me/pay-monthly-healthcare",
  },
} as const;

export type SEOPage = keyof typeof SEO_CONFIG;
